"use client"

import styles from "../../index.module.scss"
import { AdComponentTypes } from "../../types"
import { getPrefixCls } from "../../utils"

const prefixCls = getPrefixCls("ADComponent")

export default function Text(props: AdComponentTypes) {
  const { AdList, style } = props

  return (
    <div className={`${prefixCls} ${styles.text}`} style={style}>
      <ul className={styles.textList}>
        {AdList.adverts?.map((item, index) => {
          return (
            <li className={styles.textAdv} key={index}>
              <a href={item.link_url} target="_blank" rel="noreferrer">
                {item.context}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
